import React from "react";

const ProfilesCategoriesTable = ({
  profiles,
  associatedProfiles,
  profilesCategoryChangeHandler,
}) => {
  let headers,
    tableProfiles = [];
  headers = (
    <tr className="text-center">
      <th hidden>ProfileID</th>
      <th>Profile</th>
    </tr>
  );

  const selected = (ProfileID) => {
    profilesCategoryChangeHandler(
      ProfileID,
      associatedProfiles.IDAltTrackCategory
    );
  };

  if (associatedProfiles) {
    tableProfiles = profiles.map((profile, i) => {
      if (associatedProfiles.Profiles) {
        var className = associatedProfiles.Profiles.some(
          (associatedProfile) =>
            associatedProfile.ProfileID === profile.ProfileID
        )
          ? "classActiveMultiselect"
          : "";
      }

      return (
        <tr key={i} className={className}>
          <td key={"ProfileID" + i} className="d-none">
            {profile.ProfileID}
          </td>
          <td
            style={{ textAlign: "center", color: "#495057" }}
            onClick={() => selected(profile.ProfileID)}
          >
            {profile.ProfileName}
          </td>
        </tr>
      );
    });
  }

  return (
    <div
      className="divTables"
      style={{
        overflow: "auto",
        marginTop: "10px",
        boxShadow: "-10px 5px 15px #d9e6f2",
      }}
    >
      <table className="table table-hover table-sm">
        <thead
          style={{
            position: "sticky",
            top: "0",
            background: "#000",
            color: "#fff",
          }}
        >
          {headers}
        </thead>
        <tbody className="table-lg">{tableProfiles}</tbody>
      </table>
    </div>
  );
};

export default ProfilesCategoriesTable;
